import axios from 'axios';

//const authorization = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IjEiLCJ1c2VybmFtZSI6Imhhc2hpciIsImlhdCI6MTcyNTg4OTI4MSwiZXhwIjoxNzY5MDg5MjgxfQ.q-9ZuqOFjRqmUrDaqwH8TV8m2EUjqNUDElP994Td0bg';
const api = JSON.parse(localStorage.getItem('api'));
// Create an Axios instance
const axiosInstance = axios.create({
    //baseURL: api?.endpoint,
    baseURL: "http://falcon-clone.test/api/",
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${api?.token}`, // Assuming token is stored in localStorage
    },
    //withCredentials: true
});

export default axiosInstance;

export const setAxiosSetting = (token, url = "") => {
    if (url.length > 0) {
        axiosInstance.defaults.baseURL = url;
    }
    if (token) {
        axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
    } else {
        delete axiosInstance.defaults.headers['Authorization'];
    }
};
